import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/modules/authentication/authentication.service';
import { UpdateUserPayload } from 'src/app/modules/authentication/authentication.types';
import { HighlightedMessageService, MsgType } from '../highlighted-message';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  profileForm!: FormGroup;
  loading: boolean = false;


  // Dealer profile info
  dealerInfo = {
    name: '',
    address: '',
    phone: '',
  };

  constructor(
    private fb: FormBuilder,
    private moduleAuthService: AuthenticationService,
    private highlightedMessageService: HighlightedMessageService
  ) {}

  private formInit() {
    this.profileForm = this.fb.group({
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      directPhone: [null, [Validators.required]],
    });
    this.loadUserProfile();
  }

  ngOnInit(): void {
    this.formInit();
    this.loadDealerInfo();
  }

  loadDealerInfo(): void {
    const user = this.moduleAuthService.user;
    const dealerAddressParts = (user.dealer_address || '')
      .split(',')
      .map((part: string) => part.trim());
    const [company = '', address = '', city = '', state = '', zip = ''] = dealerAddressParts;

    this.dealerInfo = {
      name: company,
      address: `${address}, ${city}, ${state} ${zip}`,
      phone: user.dealer_phone || '',
    };
  }

  loadUserProfile(): void {
    const user = this.moduleAuthService.user;
    const patchValues = {
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      directPhone: user.phone
    };
    this.profileForm.patchValue(patchValues, { emitEvent: false });
    this.profileForm.updateValueAndValidity();
  }

  public get disable(): boolean {
    const validForm = this.profileForm.valid;
    return !validForm;
  }

  onSubmit(): void {
    if (this.profileForm.valid) {
      const formValues = this.profileForm.value;
      const payload: UpdateUserPayload = {
        first_name: formValues.firstName,
        last_name: formValues.lastName,
        phone: formValues.directPhone?.split('-').join('').trim(),
        email: formValues.email,
      };
      this.highlightedMessageService.removeMessage();
      this.loading = true;
      this.moduleAuthService.updateUserProfile(payload).pipe(
        catchError(({ error }) => {
          this.highlightedMessageService.displayMessage({
            type: MsgType.Error,
            message: error.message
          });
          return of(null)
        })
      ).subscribe((data) => {
        this.loading = false;
        if (data) {
          this.highlightedMessageService.displayMessage({
            type: MsgType.Success,
            message: data.message
          })
        }
      });
    } else {
      this.markFormGroupTouched(this.profileForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      control?.markAsTouched();
    });
  }
}
